/** Local storage helpers for auth token and user data (no service imports). */
export const AuthStorage = {
	getToken: () => localStorage.getItem('authToken'),

	setToken: (token) => {
		localStorage.setItem('authToken', token);
	},

	removeToken: () => {
		localStorage.removeItem('authToken');
		localStorage.removeItem('userData');
	},

	setUserData: (userData) => {
		localStorage.setItem('userData', JSON.stringify(userData));
	},

	getUserData: () => {
		try {
			const userData = localStorage.getItem('userData');
			return userData ? JSON.parse(userData) : null;
		} catch (error) {
			console.error('Error parsing user data:', error);
			return null;
		}
	}
};
